"use client";

import { useContactForm } from "@/components/providers/ContactFormProvider";

interface ContactButtonProps {
  className?: string;
  children?: React.ReactNode;
}

export default function ContactButton({ className, children }: ContactButtonProps) {
  const { openContactForm } = useContactForm();

  return (
    <button type="button" onClick={openContactForm} className={className}>
      {children || "Contact us"}
    </button>
  );
}
